module.exports = __webpack_public_path__ + "img/snow.69ffa307.jpg";